import { Component } from '@verndale/core';
import createScrollShapes from '../helpers/createScrollShapes';

class PartnerLogoBanner extends Component {
  setupDefaults() {
    this.hasBottomDecoration = this.el.classList.contains(
      'partner-logo-banner--full'
    );
    this.buildShapes();
  }

  buildShapes() {
    const { offsetHeight } = this.el;

    this.dom.shapes = createScrollShapes({
      containerEl: this.el,
      count: 4,
      prefix: 'partner-logo-banner__top-',
      offset: offsetHeight * 0.2
    });
    if (this.hasBottomDecoration) {
      this.dom.shapes = createScrollShapes({
        containerEl: this.el,
        count: 4,
        prefix: 'partner-logo-banner__bottom-',
        offset: offsetHeight
      });
    }
  }
}

export default PartnerLogoBanner;
